import React, { useContext } from 'react';
import './interdisciplinaryActivities.scss';
import CurriculumContext from '../../../../../contexts/pages/curriculum/curriculumContext';
import { baseURL } from '../../../../../api';
import ReactMarkdown from 'react-markdown';

const resolveImageUrl = (img) => {
    if (!img) return null;
    if (typeof img === 'string') {
        return img.startsWith('http') ? img : `${baseURL}${img}`;
    }
    const raw = img?.url || img?.formats?.large?.url || img?.formats?.medium?.url || img?.formats?.small?.url || (Array.isArray(img) && img[0]?.url);
    if (!raw) return null;
    return raw.startsWith('http') ? raw : `${baseURL}${raw}`;
};

const InterdisciplinaryActivities = () => {
    const { activities } = useContext(CurriculumContext) || {};

    const titulo = activities?.titulo || activities?.title || '';
    const descripcion = activities?.descripcion || activities?.contenido || '';
    const cards = activities?.tarjetas || activities?.cards || activities?.actividades || activities?.elementos || activities?.items || (Array.isArray(activities) ? activities : []);

    return (
        <section className="interdisciplinary-container">
            <div className="interdisciplinary-inner">
                {/* Encabezado Principal consumido desde Strapi */}
                <div className="interdisciplinary-header">
                    {titulo && <h1 className="interdisciplinary-title">{titulo}</h1>}
                    {descripcion && (
                        <div className="interdisciplinary-lead">
                            <ReactMarkdown>{descripcion}</ReactMarkdown>
                        </div>
                    )}
                </div>

                {/* Grid de Tarjetas consumidas 100% dinámicamente desde Strapi */}
                {cards && cards.length > 0 && (
                    <div className="interdisciplinary-grid">
                        {cards.map((card, idx) => {
                            const rawImg = card.imagen || card.image || card.foto || card.banner;
                            const imageUrl = resolveImageUrl(rawImg);
                            const rawLogo = card.logo || card.logoOverlay;
                            const logoUrl = resolveImageUrl(rawLogo);
                            const cardTitle = card.titulo || card.title || card.nombre || '';
                            const cardDesc = card.descripcion || card.description || card.contenido || '';
                            const badge = card.badge || card.etiqueta || card.subtitulo || card.categoria;
                            const puntos = Array.isArray(card.puntos)
                                ? card.puntos
                                : (typeof card.puntos === 'string'
                                    ? card.puntos.split('\n').filter(Boolean)
                                    : (Array.isArray(card.items) ? card.items : []));

                            return (
                                <article key={card.id || card._id || idx} className="inter-card">
                                    <div className="card-top-accent"></div>

                                    {imageUrl && (
                                        <div className="card-media-wrapper">
                                            <img
                                                src={imageUrl}
                                                alt={cardTitle || `Actividad ${idx + 1}`}
                                                className="card-media-img"
                                            />
                                            <div className="media-gradient-overlay"></div>

                                            {logoUrl && (
                                                <div className="logo-badge-overlay">
                                                    <img
                                                        src={logoUrl}
                                                        alt="Logo"
                                                        className="cambridge-logo-img"
                                                    />
                                                </div>
                                            )}

                                            {badge && (
                                                <span className="media-chip">
                                                    {badge}
                                                </span>
                                            )}
                                        </div>
                                    )}

                                    <div className="card-body">
                                        {cardTitle && <h2 className="card-title">{cardTitle}</h2>}
                                        {cardDesc && (
                                            <div className="card-text">
                                                <ReactMarkdown>{cardDesc}</ReactMarkdown>
                                            </div>
                                        )}

                                        {puntos && puntos.length > 0 && (
                                            <div className="card-highlights">
                                                {puntos.map((punto, pIdx) => (
                                                    <div key={pIdx} className="highlight-pill">
                                                        <span className="pill-dot"></span>
                                                        <span>{punto}</span>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </article>
                            );
                        })}
                    </div>
                )}
            </div>
        </section>
    );
};

export default InterdisciplinaryActivities;
